import styled from 'styled-components';

export const AccordionWrapper = styled.div`
  [class*='Containerstyle__Container-sc'] {
    margin-bottom: 25px;
    padding: 25px 40px;

    @media (max-width: 640px) {
      padding: 10px 15px;
    }

    button {
      font-size: 26px;
      font-weight: 400;

      @media (max-width: 640px) {
        font-size: 18px;
      }
    }
  }
`;

export const PaginatorWrapper = styled.div`
  width: 100%;
  padding: 40px 0;
  align-items: center;
  justify-content: center;
  display: flex;
  #accordion-paginator {
    width: unset;
  }
`;

export const ModalContainer = styled.div`
  text-align: center;
`;

export const ModalText = styled.div`
  color: #333333;
  font-size: 40px;
  margin-top: 20px;

  @media (max-width: 640px) {
    font-size: 24px;
  }
`;

export const AlertWrapper = styled.div`
  position: relative;
  top: 10px;
  display: none;

  [class*='Containerstyle__Container-sc'] {
    margin-bottom: 0;
    padding: 0;
  }
`;
